module.exports = __webpack_public_path__ + "static/media/alpha_17.67b47bba.png";